import {createFeatureSelector, createSelector} from '@ngrx/store';
import {DashboardState} from "./dashboard.reducer";

const selectDashboard = (state: any) => {
  return state.dashboard;
};

export const selectDashboardInfoSuccess = createSelector(
  selectDashboard,
  (state) => state.result
);

export const selectDashboardInfoFailure = createSelector(
  selectDashboard,
  (state) => state.error
);

export const selectServicesSuccess = createSelector(
  selectDashboard,
  (state) => state.services
);

export const selectServicesFailure = createSelector(
  selectDashboard,
  (state) => state.error
);

export const selectStoreService = createSelector(
  selectDashboard,
  (state) => state.result
);

export const selectStoreServiceLoading = createSelector(
  selectDashboard,
  (state) => state.loading
);

export const selectStoreServiceError = createSelector(
  selectDashboard,
  (state) => state.error
);

// Get the dashboard state
export const selectDashboardState = createFeatureSelector<DashboardState>('dashboard');

// Upload CSV
// CSV Upload selectors
export const selectUploadCSV = createSelector(
  selectDashboardState,
  (state) => state.uploadCSVResult
);

export const selectUploadCSVFailure = createSelector(
  selectDashboardState,
  (state) => state.uploadCSVError
);

// Email Upload selectors
export const selectUploadEmails = createSelector(
  selectDashboardState,
  (state) => state.uploadEmailsResult
);

export const selectUploadEmailsFailure = createSelector(
  selectDashboardState,
  (state) => state.uploadEmailsError
);
